<template>
  <v-autocomplete
    v-model="localValue"
    label="Vue Version"
    :rules="[rules.required]"
    :items="versions"
    :loading="loading"
    dense
    outlined
    persistent-hint
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
  import { fetchVersionsFromNpm } from '@/lib/fetchVersions'

  import StringValue from '@/components/form/mixins/stringValue'
  import RequiredRules from '@/components/form/mixins/required'
  export default {
    name: 'FormVueVersionSelect',
    mixins: [StringValue, RequiredRules],
    data () {
      return {
        loading: false,
        versions: [],
        hasError: false,
      }
    },
    async created () {
      try {
        const { versions } = await fetchVersionsFromNpm('vue', '^2.7.0 || ^3.3.0')
        this.versions = versions
      } catch (err) {
        this.hasError = true
        this.$emit('error', err.message)
        console.error(err.message)
      } finally {
        this.loading = false
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>
